import React, { useEffect, type FC } from "react";
import { UploadCloudIcon } from "lucide-react";
import Image from "next/image";
import { cn } from "@util/functions/utils";

export interface IFileInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  file: File | null | string | undefined;
  imageUploading?: boolean;
  fileUrl?: string;
}

const FileInput: FC<IFileInputProps> = ({
  className,
  file,
  imageUploading,
  fileUrl,
  ...props
}) => {
  const [url, setUrl] = React.useState<string | null>(null);
  useEffect(() => {
    if (file && !fileUrl) {
      const blob = new Blob([file as unknown as File as BlobPart], {
        type: (file as unknown as File).type,
      });
      const url = URL.createObjectURL(blob);

      setUrl(url);
    }
  }, [file, fileUrl]);
  return (
    <div
      className={cn(
        "w-full items-center flex h-fit relative focus:outline-none focus:ring-2 focus:ring-dark-blue-main focus:ring-offset-2 flex-col bg-white border border-grey-195 rounded-lg px-6 py-4 text-grey-550 text-xs space-y-1 aria-disabled:opacity-60 aria-disabled:cursor-not-allowed",
        className
      )}
      aria-disabled={imageUploading || props.disabled}
    >
      {(fileUrl || url) && (
        <Image
          src={fileUrl! ?? url}
          alt={(file as File)?.name}
          width="512"
          height="512"
          className="absolute inset-0 z-10 w-full h-full object-cover rounded-lg"
        />
      )}
      <input
        type="file"
        className="absolute inset-0 opacity-0 cursor-pointer z-20 w-full h-full disabled:cursor-no-drop"
        accept="image/png, image/jpeg"
        {...props}
      />
      <span className="rounded-full grid place-content-center border-[6px] border-grey-75 bg-grey-25 w-fit h-fit p-3">
        <UploadCloudIcon className="h-6 w-6 text-grey-575 " />
      </span>
      {imageUploading ? (
        <p className="w-fit mx-auto text-sm">Image Uploading</p>
      ) : (
        <p className="w-fit mx-auto text-sm">
          <span className="text-darkPurple font-bold">Click to upload</span> or
          drag and drop
        </p>
      )}
      <p>
        {imageUploading
          ? "Image is being uploaded"
          : "SVG, PNG, JPG or GIF (max. 800x400px)"}
      </p>
    </div>
  );
};
export default FileInput;
